export default __webpack_public_path__ + "static/media/francheville35.40a06950.jpg";